/*
 *
 * Do not edit directly
 * Generated on Wed, 29 Oct 2025 07:39:48 GMT
 *
 */


const theme = {
  appearances: {
    focus: {
      description: "Currently only web has good support for this. Applies when an interactive component's focus handler is triggered, such as keyboard tabbing or selection.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    hover: {
      description: "Currently web only. Applies when an interactive component's hover handler is triggered, such as on mouseover.",
      platforms: [ 'rn', 'web' ],
      type: 'state',
      values: [ true, false ]
    },
    pressed: {
      description: 'Applies while an interactive component is being physically pressed. Most visible on touchscreen taps; in React Native Web, this is visible on web mouse clicks only if the pressable is held down.',
      type: 'state',
      values: [ true, false ]
    }
  },
  rules: [
    { if: { hover: true }, tokens: { borderWidth: 3 } },
    {
      if: { pressed: true },
      tokens: { backgroundColor: '#b2b9bf', borderWidth: 3 }
    },
    { if: { focus: true }, tokens: { outerBorderColor: '#676e73' } },
    { if: { focus: true, pressed: true }, tokens: { borderWidth: 1 } }
  ],
  tokens: {
    alignSelf: 'flex-start',
    backgroundColor: '#ffffff',
    borderColor: '#676e73',
    borderRadius: 32,
    borderWidth: 1,
    color: '#676e73',
    fontName: 'HNforTELUSSA',
    fontSize: 16,
    fontWeight: '700',
    icon: null,
    iconColor: '#4b286d',
    iconSize: 24,
    iconSpace: 2,
    lineHeight: 1.5,
    minWidth: 144,
    opacity: 1,
    outerBackgroundColor: 'rgba(0, 0, 0, 0)',
    outerBorderColor: 'rgba(0, 0, 0, 0)',
    outerBorderGap: 2,
    outerBorderWidth: 2,
    paddingBottom: 12,
    paddingLeft: 28,
    paddingRight: 28,
    paddingTop: 12,
    shadow: null,
    textAlign: 'center',
    width: null
  }
}
export default theme
